import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);

const DEFAULT_SETTINGS = {
  company_name: "Hermanos Industries Pvt Ltd",
  tagline: "India's Trusted B2B Wholesale Readymade Garment Supplier",
  logo: "https://customer-assets.emergentagent.com/job_bf956fe1-1570-4257-80a8-b41c4eebcfc0/artifacts/pp6j9f5w_LOGO.png",
  address: "WZ-72, Todapur Main Road, Near Tank Road, New Delhi 110012",
  phone_primary: "+91 87997 57375",
  phone_secondary: "+91 98991 11138",
  email: "contact@hermanosindustries.com",
  whatsapp: "+918799757375",
  business_hours: "Tuesday - Sunday: 10:00 AM - 7:00 PM (Monday Closed)",
  google_maps_url: "https://maps.app.goo.gl/siSRR4PACFkiWzov8",
  social_instagram: "https://www.instagram.com/hermanos_wholesale",
  hero_headline: "Wholesale Garments. Delivered Pan-India.",
  hero_subheadline: "Trusted by 10,000+ retailers. 40+ premium brands. Bulk supply, business partnership, and enterprise-grade service.",
  hero_image: "https://images.unsplash.com/photo-1526745925052-dd824d27b9ab",
  stats_shops: "10,000+",
  stats_brands: "40+",
  stats_states: "28+",
  stats_years: "9+",
  announcement_text: "Now serving retailers across Pan India - Bulk orders welcome",
  announcement_active: true,
};

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...DEFAULT_SETTINGS, ...data });
    } catch (err) {
      // Non-fatal: keep defaults and surface for debugging without breaking the UI.
      // eslint-disable-next-line no-console
      console.warn("Site settings load failed, using defaults:", err?.message || err);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <SiteContext.Provider value={{ settings, loaded, refresh: load, setSettings }}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  return useContext(SiteContext);
}
